module.exports = __webpack_public_path__ + "img/ic_calendar.46cedd83.svg";